import React, { useState } from 'react'

const ImportCalculator = () => {

const [cifValue, setCifValue] = useState(800000);
const [engineSize, setEngineSize] = useState(2000);

const importDuty = cifValue * 0.25;

const exciseRate =
  engineSize <= 1500
    ? 0.15
    : engineSize <= 2500
    ? 0.20
    : 0.35;

const exciseDuty = (cifValue + importDuty) * exciseRate;

const idf = cifValue * 0.035;
const rdl = cifValue * 0.02;

const vatBase =
  cifValue +
  importDuty +
  exciseDuty +
  idf +
  rdl;

const vat = vatBase * 0.16;

const totalTaxes =
  importDuty +
  exciseDuty +
  idf +
  rdl +
  vat;

const landedCost = cifValue + totalTaxes;

const formatCurrency = (amount) =>
  amount.toLocaleString("en-KE");


  return (
    <section className="import-calculator">
  <div className="top-header">
    <span>Import Duty Calculator</span>
    <h2>Kenya Import Duty Calculator 2025</h2>
  </div>

  <div className="calculator-wrapper">

    <div className="calculator-inputs">

     <div className="input-group">
  <label className="duty-values">
    <span>CIF Value (Cost + Insurance + Freight)</span>

    <h3>
      KSh {formatCurrency(cifValue)}
    </h3>
  </label>

  <input
    type="range"
    min="300000"
    max="5000000"
    step="10000"
    value={cifValue}
    onChange={(e) => setCifValue(Number(e.target.value))}
  />

  <div className="range-labels">
    <span>KSh 300K</span>
    <span>KSh 5M</span>
  </div>
</div>

      <div className="input-group">
        <label className="duty-values">
          <span> Engine Size (CC)</span>
         

          <h3>{engineSize.toLocaleString()} cc</h3>
        </label>

        

        <input
          type="range"
          min="660"
          max="4500"
          step="50"
          value={engineSize}
          onChange={(e) =>
            setEngineSize(Number(e.target.value))
          }
        />

        <div className="range-labels">
          <span>660cc</span>
          <span>4500cc</span>
        </div>
      </div>

    </div>

    <div className="calculator-results">

      <div className="result-row">
        <span>CIF Value</span>
        <strong>
          KSh {formatCurrency(cifValue)}
        </strong>
      </div>

      <div className="result-row">
        <span>Import Duty (25%)</span>
        <strong>
          KSh {formatCurrency(importDuty)}
        </strong>
      </div>

      <div className="result-row">
        <span>
          Excise Duty ({exciseRate * 100}%)
        </span>
        <strong>
          KSh {formatCurrency(exciseDuty)}
        </strong>
      </div>

      <div className="result-row">
        <span>IDF (3.5%)</span>
        <strong>
          KSh {formatCurrency(idf)}
        </strong>
      </div>

      <div className="result-row">
        <span>RDL (2%)</span>
        <strong>
          KSh {formatCurrency(rdl)}
        </strong>
      </div>

      <div className="result-row">
        <span>VAT (16%)</span>
        <strong>
          KSh {formatCurrency(vat)}
        </strong>
      </div>

      <div className="result-row total">
        <span>Total Taxes & Duties</span>
        <strong>
          KSh {formatCurrency(totalTaxes)}
        </strong>
      </div>

      <div className="result-row landed">
        <span>Estimated Landed Cost</span>
        <strong>
          KSh {formatCurrency(landedCost)}
        </strong>
      </div>

      <small>
        * Estimates only. Actual KRA assessment
        may vary. Contact us for a precise quote.
      </small>
    </div>
  </div>
</section>
  )
}

export default ImportCalculator